import { Directive, HostListener, ElementRef, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[appThousandSeparator]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ThousandSeparatorDirective),
      multi: true,
    },
  ],
})
export class ThousandSeparatorDirective implements ControlValueAccessor {
  private onChange: (value: number | null) => void = () => {};
  private onTouched: () => void = () => {};

  @Input() allowDecimal: boolean = true;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let raw = input.value.replace(/,/g, '');

    const regex = this.allowDecimal ? /[^0-9.]/g : /[^0-9]/g;
    raw = raw.replace(regex, '');

    if (this.allowDecimal && (raw.match(/\./g) || []).length > 1) {
      raw = raw.substring(0, raw.lastIndexOf('.'));
    }

    const numeric = parseFloat(raw);

    if (isNaN(numeric)) {
      this.onChange(null);
      if (raw !== '.') {
        input.value = '';
      }
      return;
    }

    this.onChange(numeric);

    if (!input.value.endsWith('.')) {
      input.value = numeric.toLocaleString('en-US', {
        maximumFractionDigits: 20,
      });
    }
  }

  @HostListener('blur')
  onBlur(): void {
    this.onTouched();
    const input = this.el.nativeElement;
    const value = parseFloat(input.value.replace(/,/g, ''));
    if (!isNaN(value)) {
      input.value = value.toLocaleString('en-US');
    }
  }

  writeValue(value: number | null): void {
    if (value == null) {
      this.el.nativeElement.value = '';
    } else {
      this.el.nativeElement.value = value.toLocaleString('en-US');
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.el.nativeElement.disabled = isDisabled;
  }
}
